import { Stack, Typography } from "@mui/material"
import { ChartsTooltipContainer, useAxesTooltip } from "@mui/x-charts"
import CircleIcon from "@mui/icons-material/Circle"
import { DateTime } from "luxon"
import ChartTooltipCard from "widgets/plots/mui/ChartTooltipCard"

interface MuiWSDegreesRadiansTooltipProps {
  trigger?: "axis" | "item" | "none" | undefined
}

const MuiWSDegreesRadiansTooltip = ({ trigger }: MuiWSDegreesRadiansTooltipProps) => {
  const axes = useAxesTooltip()

  // Tooltip only for X axes, one axis of type "_time"
  // Not handling multiple axes or multiple time axes
  // Also not handling trigger "item"
  const timeAxis = axes !== null && axes[0].axisId === "_time" ? axes[0] : null

  const formattedDate = timeAxis?.axisValue
    ? DateTime.fromJSDate(timeAxis.axisValue as Date).toFormat("yyyy-MM-dd HH:mm")
    : ""

  return (
    <ChartsTooltipContainer trigger={trigger}>
      {trigger === "axis" && timeAxis && (
        <ChartTooltipCard title={formattedDate}>
          {timeAxis.seriesItems.map(
            (s) =>
              s.formattedValue !== null && (
                <Stack
                  direction="row"
                  gap={1}
                  key={s.seriesId}
                  alignItems="center"
                  width={"100%"}
                >
                  <CircleIcon sx={{ fontSize: 8, color: s.color }} />
                  <Stack
                    direction="row"
                    justifyContent={"space-between"}
                    width={"100%"}
                    gap={2}
                  >
                    <Typography>
                      {s.formattedLabel?.replace(/\s*\(rad\)\s*$/, "") ?? ""}
                    </Typography>
                    <Stack direction="row" alignItems="baseline" gap={0.5}>
                      <Typography>{s.formattedValue}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        ({((parseFloat(s.formattedValue) * Math.PI) / 180).toFixed(3)}{" "}
                        rad)
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              ),
          )}
        </ChartTooltipCard>
      )}
    </ChartsTooltipContainer>
  )
}

export default MuiWSDegreesRadiansTooltip
